import {Component, computed, effect, input, output} from '@angular/core';
import {TodoCompletion, TodoSummary} from '../../../../../api';
import {DueDateClassPipe} from '../../pipes/due-date-class.pipe';
import {DueDateFormatPipe} from '../../pipes/due-date-format.pipe';
import {DueDateFullPipe} from '../../pipes/due-date-full.pipe';
import {PartyAvatar} from '../../../../components/avatar/party-avatar.component';
import {ElciaTooltip} from '../../../../components/tooltip/elcia-tooltip.component';
import {Checkbox} from 'primeng/checkbox';
import {FormControl, ReactiveFormsModule} from '@angular/forms';

@Component({
  selector: 'elcia-todo-kanban-card-sub-todo',
  imports: [
    DueDateClassPipe,
    DueDateFormatPipe,
    DueDateFullPipe,
    PartyAvatar,
    ElciaTooltip,
    Checkbox,
    ReactiveFormsModule,
  ],
  templateUrl: './todo-kanban-card-sub-todo.html',
  styleUrl: './todo-kanban-card-sub-todo.scss',
})
export class TodoKanbanCardSubTodo {
  itemIndex = input.required<number>();
  subTodo = input.required<TodoSummary>();
  highlighted = input(false);
  onToggleState = output<TodoSummary>();


  completionControl = new FormControl<boolean>(false, {nonNullable: true});
  isDone = computed(() => this.subTodo().completion === TodoCompletion.DONE);

  constructor() {
    effect(() => {
      const isDone = this.subTodo().completion === TodoCompletion.DONE;
      if (this.completionControl.value !== isDone) {
        this.completionControl.setValue(isDone, {emitEvent: false});
      }
    });
  }

  toggleCompletion() {
    this.onToggleState.emit(this.subTodo());
  }
}
